'use client'

import * as React from 'react'
import { Tooltip as TooltipPrimitive } from 'radix-ui'
import { mtc, TextColors, TypographyStyles } from '../../../utils/style-helpers'
import { tooltipContentStyles } from './styles'
import { Text } from '../text'

const TooltipContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement> & {
    side?: 'top' | 'right' | 'bottom' | 'left'
    align?: 'start' | 'center' | 'end'
    header?: React.ReactNode
    className?: string
  }
>(
  (
    { children, side = 'top', align = 'center', header, className, ...props },
    ref
  ) => (
    <TooltipPrimitive.Content
      className={mtc(tooltipContentStyles(), className)}
      ref={ref}
      side={side}
      align={align}
      alignOffset={8}
      sideOffset={8}
      {...props}
    >
      {header && (
        <Text
          variant={TypographyStyles.LABEL_MD}
          color={TextColors.HEADER}
          className="mb-6"
        >
          {header}
        </Text>
      )}
      {children}
    </TooltipPrimitive.Content>
  )
)

TooltipContent.displayName = 'TooltipContent'

const TooltipTrigger = TooltipPrimitive.Trigger
TooltipTrigger.displayName = 'TooltipTrigger'

export const TooltipProvider = TooltipPrimitive.Provider
TooltipProvider.displayName = 'TooltipProvider'

const TooltipRoot = ({
  children,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Root>) => (
  <TooltipPrimitive.Root {...props} delayDuration={100}>
    {children}
  </TooltipPrimitive.Root>
)

type TooltipComponent = typeof TooltipRoot & {
  Trigger: typeof TooltipTrigger
  Content: typeof TooltipContent
  Provider: typeof TooltipProvider
}

const Tooltip = TooltipRoot as TooltipComponent
Tooltip.Trigger = TooltipTrigger
Tooltip.Content = TooltipContent
Tooltip.Provider = TooltipProvider

export { Tooltip }
export default Tooltip
